import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import pwcLogo from "../../assets/pwcLogo.png";
import loadingGif from "../../assets/loading.gif";

const CustomHRDLoading = ({ onCancel }) => {
  const { t } = useTranslation();

  return (
    <>
      <img
        src={pwcLogo}
        alt={t("customHRD.pwcLogoAlt")}
        style={{ height: "24px", marginBottom: "24px" }}
      />

      <h1
        className="title hrd-loading-title"
        role="alert"
        aria-live="polite"
      >
        {t("customHRD.redirectingPage.title")}
      </h1>

      <img
        src={loadingGif}
        alt={t("customHRD.loadingImageAlt")}
        className="hrd-loading-gif"
      />

      <button
  type="button"
  className="hrd-loading-cancel"
  onClick={onCancel}
>
  {t("customHRD.redirectingPage.cancelButton")}
</button>
    </>
  );
};

CustomHRDLoading.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default CustomHRDLoading;